const s = {
  // Chip has no 'lg' and 'xl' size. So we don't support that in multi-select.
  EXTRA_SMALL: "xs",
  SMALL: "sm",
  DEFAULT: "md"
}, t = {
  xs: "xs",
  sm: "xs",
  md: "sm"
}, m = {
  xs: 1.4,
  sm: 0.4,
  md: 0.2
}, o = {
  MULTI_SELECT_SIZES: s,
  CHIP_SIZES: t,
  CHIP_TOP_POSITION: m
};
export {
  t as CHIP_SIZES,
  m as CHIP_TOP_POSITION,
  s as MULTI_SELECT_SIZES,
  o as default
};
//# sourceMappingURL=combobox-multi-select-constants.js.map
